import {RequestCacheEntry} from './request-cache-entry';

/**
 * Represents a store for a cache.
 */
export abstract class CacheStore {
    /**
     * Gets the cache entry or undefined if it does not exist.
     *
     * @param key The key of the entry.
     * @return The cache entry or undefined if it does not exist.
     */
    abstract get(key: string): RequestCacheEntry | undefined;

    /**
     * Removes the cache entry.
     *
     * @param key The key of the entry.
     */
    abstract delete(key: string): void;

    /**
     * Sets the cache entry.
     *
     * @param key The key of the entry.
     * @param cacheEntry The cache entry.
     */
    abstract put(key: string, cacheEntry: RequestCacheEntry): void;
}
